import axios from "axios";
import {WeightUnit} from "../../models";
import {WidgetType} from "./enums/widgetType";
import {CalculatorC2CValues} from "../calculator/calculatorC2C";

const rootElement = document.getElementById('react-widgets') as HTMLElement
const widgetType: WidgetType = rootElement?.dataset?.widget as WidgetType

export const api = axios.create({
    baseURL: 'https://portal.trtexpress.com/api/',
    //baseURL: 'https://portal-dev.trtexpress.com/api/',
    //baseURL: 'https://localhost:5001/api/',
    headers: {"Accept": "*/*", 'Content-Type': 'application/json'},
    timeout: 10000,
});

export const getToken = () => {
    const username = 'kegax27028@byorby.com';
    const password = 'Password123!'
    return api.post('Token', {
        "email": username,
        "password": password,
        "grantType": "password",
        "rememberMe": false
    });
}

export const getUserInfo = () => {
    return api.get("User")
}

export const getCountries = () => {
    return api.get("organizations/1/countries")
}

export const getCities = (countryCode: string, search: string) => {
    return api.post("organizations/1/cities", {countryCode, search})
}

export const getQuote = (originCountryCode: string,
                         destinationCountryCode: string,
                         weight: number,
                         weightUnit: WeightUnit,
                         contactId: number) => {
    return api.post(`organizations/1/workflowTriggers/387c2eb6-aedc-4591-b3f3-4846d121c8c2`,
        {
            variables: {
                commodities: [
                    {
                        "pieces": 1,
                        "weight": weight,
                        "weightUnit": weightUnit,
                    }
                ],
                customerId: contactId,
                countryCode: destinationCountryCode,
                postalCode: "",
                isDangerousGoods: false,
                lang: "en-US",
                additionalServices: {}
            }
        })
}


export const getQuoteParcels = ({
                                    originCountryCode,
                                    originZip,
                                    destinationCountryCode,
                                    destinationZip,
                                    weight,
                                    weightUnit,
                                    length,
                                    width,
                                    height,
                                    contactId
                                }: CalculatorC2CValues) => {
    return api.post(`organizations/1/workflowTriggers/f1fc5dbc-53a2-4846-9b30-329f308019b7`,
        {
            variables: {
                finalMileDestinationCountryCode: destinationCountryCode,
                finalMileAdditionalServices: null,
                shipperPostalCode: originZip,
                finalMileDestinationPostalCode: destinationZip,
                customerId: contactId,
                commodities: [
                    {
                        commodityId: 0,
                        description: "Box Container",
                        pieces: 1,
                        customValues: {
                            "purposeOfCommodity": "Gift",
                            "dangerousItems": ""
                        },
                        dimensionsUnit: "In",
                        weightUnit: weightUnit,
                        volumeUnit: "Vlb",
                        length: length,
                        width: width,
                        height: height,
                        weight: weight,
                        weightTotal: weight
                    }
                ],
                isDangerousGoods: false
            }
        })
}

export const getLocations = (variables: any) => {
    return api.post(`organizations/1/workflowTriggers/8a0004f1-fcc3-4948-b7a6-1fb6699c09db`,
        {
            variables
        })
}


